<template>
  <PageLayout>
    <template slot="header">
      <div class="d-flex m-3 mx-lg-0">
        <breadcrumb :list="breadcrumbList" />
        <ExportData
          id="exportData"
          class="ml-sm-2 mt-2 mt-sm-0"
          :canExport="$can('use', 'report.export')"
          :hasXlsx="true"
          :hasCsv="false"
          @export="handleExportClick"
        />
        <GroupsTreeSelect class="ml-md-1" @selectItem="selectGroupItem" />
      </div>
    </template>
    <template slot="main">
      <div v-if="participation.loading" class="loading">
        <loading />
        <p>{{ reportsResources.loading }}</p>
      </div>
      <div class="page-reports" v-if="!participation.loading">
        <b-row class="arrows ie-11-arrows">
          <span class="mdi mdi-arrow-right-bold-circle"></span>
          <span class="mdi mdi-arrow-right-bold-circle"></span>
        </b-row>
        <b-row :class="{ 'inactive-group-card': groupSelected.inactive }">
          <b-col xl="4" class="mb-4">
            <b-card
              class="text-center participation-card"
              v-bind:class="{ admin: isAdmin }"
            >
              <header slot="header" class="text-left">
                <span v-html="reportsResources.header.invited" />
                <GroupsInactive v-if="groupSelected.inactive" />
              </header>
              <div class="invited-count mt-5" id="invitedCount">
                {{ participation.invitedCount }}
              </div>
              <div class="invited-date">
                {{ reportsResources.header.since }}
                {{
                  participation.createdAt
                    ? this.$moment(participation.createdAt).format('DD/MM/YYYY')
                    : ''
                }}
              </div>

              <can I="see" a="inviteUsers">
                <div class="mt-4">
                  <b-button
                    id="btn-invite-page"
                    type="button"
                    :to="{ name: 'dashboard.users.send.invite' }"
                    class="btn btn-tertiary btn-lg"
                  >
                    <span class="d-lg-inline-block">{{
                      buttonsTitle.inviteMore
                    }}</span>
                  </b-button>
                </div>
              </can>
              <b-row class="arrows-mobile mt-2 pt-1">
                <div class="white-square"></div>
                <span class="mdi mdi-arrow-down-bold-circle"></span>
              </b-row>
            </b-card>
          </b-col>
          <b-col xl="4" class="mb-4">
            <b-card
              class="text-center participation-card"
              v-bind:class="{ admin: isAdmin }"
            >
              <header slot="header">
                <b-row>
                  <b-col class="text-left">
                    <span v-html="reportsResources.header.confirmed" />
                    <GroupsInactive v-if="groupSelected.inactive" />
                  </b-col>
                  <b-col v-if="true" cols="1">
                    <tooltip-info
                      id="tooltipConfirmed"
                      :contentClasses="'float-right'"
                      :message="reportsResources.tooltips.confirmed"
                      type="ask"
                    ></tooltip-info>
                  </b-col>
                </b-row>
              </header>
              <div class="flex justify-content-center" id="confirmedCount">
                <OverView
                  :score="participation.confirmedCount"
                  :maxValue="participation.invitedCount"
                  :name="'confirmed'"
                />
              </div>
              <can I="access" a="page.users">
                <div>
                  <b-button
                    id="btn-manage-user"
                    type="button"
                    class="btn btn-primary btn-lg btn-overview"
                    @click="onManageClick"
                  >
                    <span class="d-lg-inline-block">
                      {{ buttonsTitle.manage }}
                    </span>
                  </b-button>
                </div>
              </can>
              <b-row class="arrows-mobile">
                <div class="white-square"></div>
                <span class="mdi mdi-arrow-down-bold-circle"></span>
              </b-row>
            </b-card>
          </b-col>
          <b-col xl="4" class="mb-4">
            <b-card
              class="text-center participation-card"
              v-bind:class="{ admin: isAdmin }"
            >
              <header slot="header">
                <b-row>
                  <b-col class="text-left">
                    <span v-html="reportsResources.header.active" />
                    <GroupsInactive v-if="groupSelected.inactive" />
                  </b-col>
                  <b-col v-if="true" cols="1">
                    <tooltip-info
                      id="tooltipActive"
                      :contentClasses="'float-right'"
                      :message="reportsResources.tooltips.active"
                      type="ask"
                    ></tooltip-info>
                  </b-col>
                </b-row>
              </header>
              <div class="flex justify-content-center" id="activeCount">
                <OverView
                  :score="participation.activeCount"
                  :maxValue="
                    participation.invitedCount > 0 &&
                    participation.activeCount === 0 &&
                    participation.confirmedCount === 0
                      ? 1
                      : participation.confirmedCount
                  "
                  :name="'active'"
                />
              </div>
              <can I="access" a="page.users">
                <div>
                  <b-button
                    id="btn-manage-user"
                    type="button"
                    @click="onManageClick"
                    class="btn btn-primary btn-lg btn-overview"
                  >
                    <span class="d-lg-inline-block">
                      {{ buttonsTitle.manage }}
                    </span>
                  </b-button>
                </div>
              </can>
            </b-card>
          </b-col>
        </b-row>
        <b-row :class="{ 'inactive-group-card': groupSelected.inactive }">
          <b-col xl="4" class="mb-4">
            <b-card class="live-summary">
              <header slot="header">
                <b-row>
                  <b-col :title="sectionTitles">
                    <h6>{{ reportsResources.overall.headerEngaje }}</h6>
                    <small>
                      {{
                        `${participation.activeCount}
                        ${reportsResources.overall.activeUsers} /
                        ${participation.invitedCount}
                        ${reportsResources.overall.invited}`
                      }}
                    </small>
                  </b-col>
                </b-row>
              </header>
              <div class="flex">
                <Overall :score="engajePercent" :isPercentage="true" />
              </div>
              <b-row>
                <b-col class="m-2 pt-4">
                  <p>
                    {{
                      reportsResources.overall.tipEngaje
                        | parse({
                          INVITED: participation.invitedCount,
                          ACTIVE: participation.activeCount,
                          DAYS: participation.daysOfInactive,
                        })
                    }}
                  </p>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col class="mb-4">
            <b-card class="live-summary">
              <header slot="header">
                <b-row>
                  <b-col :title="sectionTitles">
                    <h6>{{ reportsResources.overall.titleEngaje }}</h6>
                  </b-col>
                </b-row>
              </header>
              <div>
                <VueApexCharts
                  type="line"
                  :options="chartOptionsInvited"
                  :series="seriesInvited"
                >
                </VueApexCharts>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row :class="{ 'inactive-group-card': groupSelected.inactive }">
          <b-col xl="4" class="mb-4">
            <b-card class="live-summary">
              <header slot="header">
                <b-row>
                  <b-col :title="sectionTitles">
                    <h6>{{ reportsResources.overall.headerResponders }}</h6>
                    <small>
                      {{
                        `${participation.activeCount}
                        ${reportsResources.overall.activeUsers} /
                        ${participation.confirmedCount}
                        ${reportsResources.overall.confirmed}`
                      }}
                    </small>
                  </b-col>
                </b-row>
              </header>
              <div class="flex">
                <Overall
                  :score="
                    engajePercent >= 0
                      ? participation.participationRate / 10
                      : undefined
                  "
                  :isPercentage="true"
                />
              </div>
              <b-row>
                <b-col class="m-2 pt-4">
                  <p>
                    {{
                      reportsResources.overall.tipResponders
                        | parse({
                          CONFIRMED: participation.confirmedCount,
                          ACTIVE: participation.activeCount,
                          DAYS: participation.daysOfInactive,
                        })
                    }}
                  </p>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col class="mb-4">
            <b-card class="live-summary">
              <header slot="header">
                <b-row>
                  <b-col :title="sectionTitles">
                    <h6>{{ reportsResources.overall.titleResponders }}</h6>
                  </b-col>
                </b-row>
              </header>
              <div>
                <VueApexCharts
                  type="line"
                  :options="chartOptionsConfirmed"
                  :series="seriesConfirmed"
                >
                </VueApexCharts>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>

      <modal-plans
        ref="component-modal-plans"
        :title="resources.general.menu.participation"
        @hide="handleHide"
      >
      </modal-plans>
    </template>
  </PageLayout>
</template>

<script>
import { mapGetters } from 'vuex'
import PageLayout from '@/components/Home/PageLayout.vue'
import OverView from '@/components/Charts/OverView.vue'
import Overall from '@/components/Charts/Overall.vue'
import ability from '@/helpers/ability'
import TooltipInfo from '@/components/TooltipInfo.vue'
import ModalPlans from '@/components/Modal/ModalPlans.vue'
import { getUser } from '@/service/user'
import Breadcrumb from '@/components/Shared/Breadcrumb.vue'
import GroupsTreeSelect from '@/components/Groups/GroupsTreeSelect.vue'
import Loading from '@/components/Shared/Loading.vue'
import VueApexCharts from 'vue-apexcharts'
import ExportData from '@/components/Reports/ExportData.vue'
import GroupsInactive from '@/components/Groups/GroupsInactive.vue'

export default {
  components: {
    OverView,
    PageLayout,
    TooltipInfo,
    Overall,
    Breadcrumb,
    GroupsTreeSelect,
    ModalPlans,
    Loading,
    VueApexCharts,
    ExportData,
    GroupsInactive,
  },

  computed: {
    chartOptionsConfirmed() {
      const arr = [...this.participation.history.confirmedResponders].sort()
      return this.getChartOptions({ min: arr[0], max: arr[arr.length - 1] })
    },

    chartOptionsInvited() {
      const arr = [...this.participation.history.totalResponders].sort()
      return this.getChartOptions({ min: arr[0], max: arr[arr.length - 1] })
    },

    seriesConfirmed() {
      return [
        {
          name: this.reportsResources.overall.participation,
          data: this.participation.history.confirmedResponders,
        },
      ]
    },

    seriesInvited() {
      return [
        {
          name: this.reportsResources.overall.participation,
          data: this.participation.history.totalResponders,
        },
      ]
    },

    isAdmin() {
      return getUser().role === 'admin'
    },

    ...mapGetters({
      resources: 'resources',
      currentGroup: 'user/currentGroup',
      participation: 'participation/participation',
      selectedGroup: 'user/selectedGroup',
    }),

    engajePercent() {
      return (
        (this.participation.activeCount * 10) / this.participation.invitedCount
      )
    },

    groupId() {
      return this.$route.params.groupId
    },

    sectionTitles() {
      return this.reportsResources.title
    },

    buttonsTitle() {
      return this.resources.general.buttons
    },

    reportsResources() {
      return this.resources.page.reports.participation
    },

    breadcrumbList() {
      return [
        {
          label: this.resources.general.menu.report,
        },
        {
          label: this.resources.general.menu.participation,
        },
      ]
    },
  },

  methods: {
    getChartOptions({ min, max }) {
      const colorStops = this.getColorStops({ min, max })
      return {
        stroke: {
          width: 2,
          curve: 'smooth',
          lineCap: 'round',
        },
        xaxis: {
          type: 'datetime',
          categories: this.participation.history.dates,
          labels: {
            format: 'dd/MM/yyyy',
            style: {
              fontSize: '10px',
            },
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            shadeIntensity: 1,
            type: 'vertical',
            colorStops,
          },
        },
        tooltip: {
          marker: {
            show: false,
          },
          x: {
            format: 'dd/MM/yyyy',
          },
        },
        responsive: [
          {
            breakpoint: 400,
            options: {
              chart: {
                type: 'area',
              },
            },
          },
        ],
      }
    },

    getColorStops({ min, max }) {
      const colorStops = []

      if (max < 50) {
        colorStops.push({
          offset: 0,
          color: '#eb235e', // red
          opacity: 1,
        })
        return colorStops
      } else if (max < 75) {
        colorStops.push({
          offset: 0,
          color: '#eda008', // yellow
          opacity: 1,
        })
        if (min < 50) {
          const offset = (100 * (max - 50)) / (max - min)
          colorStops.push({
            offset,
            color: '#eb235e', // red
            opacity: 1,
          })
        }
        return colorStops
      } else if (max >= 75) {
        colorStops.push({
          offset: 0,
          color: '#23ebb0', // green
          opacity: 1,
        })
        if (min < 75) {
          const offset = (100 * (max - 75)) / (max - min)
          colorStops.push({
            offset,
            color: '#eda008', // yellow
            opacity: 1,
          })
          if (min < 50) {
            const offset = (100 * (max - 50)) / (max - min)
            colorStops.push({
              offset,
              color: '#eb235e', // red
              opacity: 1,
            })
          }
        }
      }
      return colorStops
    },

    handleExportClick() {
      this.$can('use', 'report.export')
        ? this.exportFile()
        : this.$refs['component-modal-plans'].show()
    },

    exportFile() {
      // eslint-disable-next-line no-undef
      const env = window.env || process.env

      window.open(
        `${env.VUE_APP_EXPORTER_API_HOST}/participation/${this.groupId}/xlsx?token=${localStorage.jwt}&language=${localStorage.languageabrev}`,
        '_blank'
      )
    },

    onManageClick() {
      const route =
        this.groupId !== 'company'
          ? { path: `/groups/${this.groupId}` }
          : { path: '/users' }
      const { href } = this.$router.resolve(route)
      window.open(href, '_blank')
    },

    loadParticipation(groupId) {
      this.$store.dispatch('participation/getParticipationByGroup', groupId)
    },

    selectGroupItem(group) {
      if (group._id !== 'company' && !group.enable) {
        this.$refs['component-modal-plans'].show()
        return false
      }

      this.loadParticipation(group._id)
      this.$router.push({
        name: 'participation',
        params: { groupId: group._id },
      })
      this.$store.commit('user/updateCurrentGroup', group)

      this.groupSelected = group
    },

    handleHide() {
      this.$store.dispatch('user/updateSelectedGroup', undefined)
    },
  },

  created() {
    this.groupSelected = this.currentGroup || {}

    const selectedGroup = this.selectedGroup
    if (selectedGroup && selectedGroup !== this.groupId) {
      this.$store.dispatch(
        'participation/getParticipationByGroup',
        selectedGroup
      )
      return this.$router.push({
        name: 'participation',
        params: { groupId: selectedGroup },
      })
    }

    this.$store.dispatch('participation/getParticipationByGroup', this.groupId)
  },

  mounted() {
    this.$ability.update(ability().rules)
    this.$root.$emit('setPageTitle', { context: this, path: 'participation' })
    this.$root.$emit('track', {
      event: 'Acessou relatorio de participacao',
      data: { category: 'App' },
    })
  },

  beforeDestroy() {
    this.$store.commit('user/updateCurrentGroup', undefined)
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';
_:-ms-fullscreen,
:root .ie-11-arrows {
  justify-content: space-around;
  margin: 0px 145px 0px 145px;
}

header {
  .d-flex {
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }
}

.row {
  @media (max-width: 1199px) {
    margin-right: 0px;
    margin-left: 0px;
  }
}

.arrows {
  @media (max-width: 1199px) {
    z-index: -1;
    opacity: 0;
  }

  justify-content: space-evenly;
  margin: 0px 20px 0px 20px;
  position: relative;
  top: 170px;
  z-index: 1;

  .mdi-arrow-right-bold-circle {
    color: map-get($theme-colors, 'gray01');
    font-size: 70px;
  }
}

.arrows-mobile {
  .white-square {
    z-index: -1;
    background: white;
    position: absolute;
    height: 36px;
    width: 36px;
    top: 37px;
  }

  @media (max-width: 1199px) {
    z-index: 1;
    opacity: 1;
  }

  @media (min-width: 426px) {
    top: -14px;
  }

  justify-content: center;
  position: relative;
  top: 7px;
  z-index: -1;
  opacity: 0;

  .mdi-arrow-down-bold-circle {
    color: map-get($theme-colors, 'gray01');
    font-size: 70px;
  }
}

.participation-card {
  .card-body {
    height: 240px;

    .btn-lg {
      width: 200px;
      height: 42px;

      &.btn-overview {
        margin-top: -40px;
      }
    }

    .invited-count {
      text-align: center;
      font-size: 65px;
    }

    .invited-date {
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      color: map-get($theme-colors, 'gray02');
    }
  }
}

.metrics-container .subTitle {
  color: map-get($theme-colors, 'gray02');
  font-size: 12px;
  text-decoration: none;
  margin: 0;
}

.empty-state-box {
  overflow: hidden;
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: calc(100vh - 350px);
  text-align: center;
  width: 100%;

  video {
    text-align: center;
    min-height: 130px;
    max-height: 500px;
    max-width: 100%;
  }

  label {
    color: map-get($theme-colors, 'gray03');
    font-size: xx-large;
    @media (max-width: 991.98px) {
      font-size: large;
    }
  }
}

.page-reports {
  margin-bottom: 40px;
  margin-top: -107px;
}

.nav.header .nav-link {
  margin: 0rem !important;
}

.card {
  .card-header {
    font-size: 24px;
  }
  @media (max-width: 575.98px) {
    // sm
    .card-body {
      padding: 0px 0px 10px 0px;
      margin: 0px;
    }
  }

  .flex {
    display: flex;
    justify-content: center;

    @media (max-width: 767px) {
      justify-content: center;
    }
  }
}

.loading {
  margin: 0 auto;
  text-align: center;
}

.admin {
  .card-body {
    height: 290px;
  }
}

.live-summary {
  height: 100%;
}

small {
  font-size: 75%;
}

.inactive-group-card {
  .card,
  .card-header {
    background: map-get($theme-colors, 'gray08') !important;
  }
}
</style>
